"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _listModule = _interopRequireDefault(require("./list.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var List = function List(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])(_listModule["default"].list, className)
  }, children);
};

List.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
List.defaultProps = {
  className: '',
  children: null
};
var _default = List;
exports["default"] = _default;